import { AxiosResponse } from 'axios'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import casinoService from '../../services/casino.service'
import {
  selectCasinoMatchList,
} from '../../redux/actions/casino/casinoSlice'

import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { CustomLink } from '../_layout/elements/custom-link'
import CasinoListItemInt from '../CasinoList/CasinoListItemInt'
import authService from '../../services/auth.service'
import { isMobile } from 'react-device-detect'
import './casino.css'
import { useGameOverlayHistory } from '../../hooks/useGameOverlayHistory'
import GameAlertBanner from '../../components/GameAlertBanner/GameAlertBanner'

const DEFAULT_HP_VIS_CONFIG = { overrideImages: {} as Record<string, string>, useCustomImage: {} as Record<string, boolean> }

const CasinoHomepage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const gamesList = useAppSelector<any>(selectCasinoMatchList)
  const [searchParams] = useSearchParams();
  const queryp = useParams();
  const category = searchParams.get("category")
  const [games, setGames] = React.useState<any>([])
  const [provider, setProvider] = React.useState<any>([])
  const [categorylist, setCategoryList] = React.useState<any>([])
  const [gamePlay, setGamePlay] = React.useState<any>()
  const [gameUrl, setGameUrl] = React.useState<string>('')
  const [showIframe, setShowIframe] = React.useState(false)
  const [catName, setCatName] = React.useState<string>('')
  const [searchQuery, setSearchQuery] = useState("");
  const [hpVisConfig, setHpVisConfig] = React.useState(DEFAULT_HP_VIS_CONFIG)

  useEffect(() => {
    casinoService.getCasinoVisibilityConfig()
      .then((res: AxiosResponse<any>) => {
        const data = res.data?.data || res.data || {}
        setHpVisConfig({ overrideImages: data.overrideImages || {}, useCustomImage: data.useCustomImage || {} })
      })
      .catch(() => setHpVisConfig(DEFAULT_HP_VIS_CONFIG))
  }, [])
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track dropdown visibility
  const dropdownRef = useRef(null);
  const [activeCategory, setActiveCategory] = useState<string>(provider?.[0]?._id || "");

  const closeCasinoGame = useCallback(() => {
    setGamePlay(undefined)
    setGameUrl('')
    setShowIframe(false)
  }, [])

  const launchGameIfLoggedIn = useCallback(
    (game: any) => {
      if (!authService.getToken()) {
        toast.info('Please log in to play.', { position: 'top-center', autoClose: 3500 })
        navigate('/dash', {
          state: {
            openLogin: true,
            from: `${location.pathname}${location.search}`,
          },
        })
        return
      }
      setGamePlay(game)
    },
    [navigate, location.pathname, location.search]
  )

  const closeGameOverlay = useGameOverlayHistory(!!gamePlay, closeCasinoGame)

  console.log(queryp)
  React.useEffect(() => {
    const homepageCode = parseInt(queryp.homepage_code || '1')
    casinoService
      .getCasinoByHomepageCode(homepageCode)
      .then((res: AxiosResponse<any>) => {
        const data = res.data
        setGames(data.result)
        setProvider([])
        setCategoryList(data.category)
        setCatName(data?.category?.['0']?._id || '')
      })
      .catch(() => {
        setGames([])
        setCategoryList([])
      })
  }, [queryp.homepage_code])

  // Add/remove body class when game is playing; scroll to top when opening game
  React.useEffect(() => {
    if (gamePlay) {
      document.body.classList.add('casino-game-playing');
      window.scrollTo(0, 0);
    } else {
      document.body.classList.remove('casino-game-playing');
    }
    return () => {
      document.body.classList.remove('casino-game-playing');
    };
  }, [gamePlay]);

  // Reset showIframe when game closes (delayed mount runs again on next open)
  React.useEffect(() => {
    if (!gamePlay) setShowIframe(false);
  }, [gamePlay]);

  // Delay iframe mount ~120ms after gameUrl is ready (iOS Safari playbook)
  React.useEffect(() => {
    if (!gameUrl) return;
    const t = setTimeout(() => setShowIframe(true), 120);
    return () => clearTimeout(t);
  }, [gameUrl]);

  React.useEffect(() => {
    if (gamePlay) {
      const payload: any = {
        gameCode: gamePlay.identifier,
        lobby_url: gamePlay.identifier,
        ipAddress: authService.getIpAddress(),
        isMobile: isMobile,
      }

      // ✅ Wrap in try-catch to prevent uncaught errors
      const loadCasino = async () => {
        try {
          const res = await casinoService.getplaycasino(payload)
          const data = res?.data
          const raw = data?.data?.url ?? data?.data?.playUrl ?? data?.data?.play_url ?? data?.data?.gameUrl ?? data?.url ?? data?.playUrl
          const url = raw && typeof raw === 'string' ? raw.trim() : null
          if (url) {
            setGameUrl(url)
          } else {
            toast.error('Game could not be loaded. Please try again.')
            setGamePlay(undefined)
          }
        } catch (error: any) {
          console.log('Casino play error:', error)

          // ✅ Handle 401 errors gracefully without logging out
          if (error.response?.status === 401 || error.response?.status === 500) {
            // Parse error message if available
            let errorMsg = 'This is not available currently'

            try {
              const responseMsg = error.response?.data?.message
              if (responseMsg && typeof responseMsg === 'string') {
                // Try to parse nested JSON error message
                const parsed = JSON.parse(responseMsg)
                if (parsed.msg) {
                  const innerParsed = JSON.parse(parsed.msg)
                  errorMsg = innerParsed.message || innerParsed.error || errorMsg
                }
              }
            } catch (parseError) {
              // If parsing fails, use default message
              console.log('Could not parse error message:', parseError)
            }

            toast.error(errorMsg, {
              position: 'top-center',
              autoClose: 4000
            })
            // Reset game play to close the iframe
            setGamePlay(undefined)
          } else {
            // For other errors, show generic message
            toast.error('Unable to load casino game. Please try again later.', {
              position: 'top-center',
              autoClose: 3000
            })
            setGamePlay(undefined)
          }
        }
      }

      loadCasino()
    }
  }, [gamePlay])

  useEffect(() => {
    if (categorylist.length > 0 && !catName) {
      setCatName(categorylist[0]._id);
    }
  }, [categorylist]);

  // Search functionality
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.trim().length >= 2) {
        setIsLoading(true)
        setIsDropdownOpen(true)

        casinoService.searchCasinoGames(searchQuery)
          .then((res: AxiosResponse<any>) => {
            setSuggestions(res.data.result || [])
            setIsLoading(false)
          })
          .catch((error) => {
            console.error('Search error:', error)
            setSuggestions([])
            setIsLoading(false)
          })
      } else {
        setSuggestions([])
        setIsDropdownOpen(false)
      }
    }, 300) // Debounce 300ms

    return () => clearTimeout(delayDebounceFn)
  }, [searchQuery])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !(dropdownRef.current as any).contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSuggestionClick = (game: any) => {
    launchGameIfLoggedIn(game)
    setSearchQuery('')
    setSuggestions([])
    setIsDropdownOpen(false)
  }

  console.log(provider)
  return (
    <div className="casino-page-wrap">
      <div className="w-100 mb-4">
        <div className="nav-search-main mb-1">
          <div className="nav-search-input-wrapper w-100" ref={dropdownRef}>
            <input
              type="text"
              placeholder="Search Casino Games"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => searchQuery && setIsDropdownOpen(true)}
              className="nav-search-input w-100"
            />
            <span className="nav-search-icon">
              {isLoading ? "⌛" : "🔍"}
            </span>

            {/* Suggestions dropdown */}
            {isDropdownOpen && searchQuery && suggestions.length > 0 && (
              <div className="nav-search-suggestions">
                {suggestions.map((game: any, index: number) => (
                  <div
                    key={index}
                    className="search-suggestion-item"
                    onClick={() => handleSuggestionClick(game)}
                    style={{
                      cursor: 'pointer',
                      padding: '10px',
                      borderBottom: '1px solid #eee',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                  >
                    <img
                      src={game.image_url}
                      alt={game.game_name}
                      style={{
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '4px'
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {game.game_name}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {game.provider}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* No results message */}
            {isDropdownOpen && searchQuery && suggestions.length === 0 && !isLoading && (
              <div className="nav-search-suggestions">
                <div className="no-results">No matches found</div>
              </div>
            )}
          </div>
        </div>

        {/* Category tabs - Same UI as casino-int */}
        <div className="w-100 mt-2">
          <nav className="casino-nav ">
            {categorylist?.map((Item: any, key: number) => {
              const isCategoryActive =
                catName === Item._id || (!catName && key === 0);

              return (
                <a
                  key={key}
                  onClick={() => setCatName(Item._id)}
                  href="javascript:void(0);"
                  className={`nav-tab py-2 transition-all ${isCategoryActive ? "active text-white" : "bg-background text-foreground"
                    }`}
                >
                  <span className="nav-text">{Item._id}</span>
                </a>
              );
            })}
          </nav>
        </div>

        <div className="casino-list mt-2">
          {games.length > 0 && (
            <CasinoListItemInt games={games} setGamePlay={launchGameIfLoggedIn} overrideImages={hpVisConfig.overrideImages} useCustomImage={hpVisConfig.useCustomImage} />
          )}
        </div>
      </div>

      <GameAlertBanner gamePlay={gamePlay} />

      {/* Game iframe OUTSIDE main content (avoids freeze); mount only when gameUrl ready + 120ms delay */}
      {gamePlay?.game_name && (
        <div className="slot-iframe show">
          <div className="slot-header">
            <div className="title"><h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "400" }}>{gamePlay?.game_name}</h4></div>
            <div className="close-slot-frame" onClick={closeGameOverlay}>EXIT</div>
          </div>
          {gameUrl ? (
            showIframe ? (
              <iframe
                src={gameUrl}
                title={gamePlay?.game_name}
                allow="autoplay; fullscreen; clipboard-read; clipboard-write"
                allowFullScreen
                style={{ width: '100%', border: 'none' }}
              />
            ) : (
              <div className="slot-iframe-loading">
                <div className="lds-hourglass" />
              </div>
            )
          ) : (
            <div className="slot-iframe-loading">
              <div className="lds-hourglass" />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default CasinoHomepage

